module.exports = __webpack_public_path__ + "static/media/julio.2f6bd694.jpg";